import { APICore } from './apiCore';

import axiosInstance from 'src/utils/axios';
import config from 'src/config';
const apiBaseUrl = config.API_URL;
const api = new APICore();

// account
function login(params: { UserCode: string; Pwd: string; VerifyUser: string; HostIP: string }) {
    const baseUrl = `/auth/login/`;
    // axiosInstance.post('/login/', params).then(async function (response) {
    //     console.log(response, 'fff');
    // });
    return api.create(`${baseUrl}`, params);
}

function logout() {
    const baseUrl = '/logout/';
    return api.create(`${baseUrl}`, {});
}

function signup(params: any) {
    const baseUrl = '/auth/signup/';
    return api.create(`${baseUrl}`, params);
}

function forgotPassword(params: { email: string }) {
    const baseUrl = '/forget-password/';
    return api.create(`${baseUrl}`, params);
}

export { login, logout, signup, forgotPassword };
